<template>
  <v-dialog
    v-model="dialog"
    data-testId="dialog"
    persistent
    width="30%">
    <v-card data-testId="card">
      <v-card-title
        data-testId="card-title-title"
        class="headline grey lighten-2"
        primary-title>
        {{ title }}
      </v-card-title>
      <v-card-text data-testId="card-text">
        <v-form
          ref="form"
          v-model="isValidationOk"
          lazy-validation>
          <v-container
            py-0>
            <v-layout
              wrap>
              <v-flex
                xs12
                md12
                lg12>
                <v-text-field
                  v-model.number="newValue"
                  :label="labelText"
                  :rules="rules.required.concat(rules.range)"
                  data-testId="text-field"
                  counter
                  class="dover-input"/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider/>
      <v-card-actions data-testId="card-actions">
        <v-flex
          xs9
          md9
          text-xs-right>
          <v-btn
            data-testId="btn-Cancel"
            color="primary"
            flat
            @click="closeDialog(false)">
            {{ $t('Cancel') }}
          </v-btn>
        </v-flex>
        <v-flex
          xs3
          md3
          text-xs-right>
          <v-btn
            :disabled="!isValidationOk"
            data-testId="btn-Ok"
            color="secondary"
            flat
            @click="closeDialog(true)">
            {{ $t('Ok') }}
          </v-btn>
        </v-flex>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import Vue from 'vue'

export default {
  props: {
    componentKey: {
      type: String,
      required: true
    },
    initialValue: {
      type: Number,
      required: true
    },
    minValue: {
      type: Number,
      required: true
    },
    maxValue: {
      type: Number,
      required: true
    },
    dialog: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    labelText: {
      type: String,
      required: true
    },
    customPar1: {
      type: [Number, String],
      required: true
    },
    customPar2: {
      type: [Number, String],
      required: true
    }
  },
  data: () => ({
    isValidationOk: true,
    newValue: 0,
    rules: {
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ],
      range: [ true ]
    }
  }),
  watch: {
    initialValue () {
      this.newValue = this.initialValue
    }
  },
  mounted () {
    this.newValue = this.initialValue
    this.rules.range = [ v => Vue.prototype.Maglink.RulesRange(v, this.minValue, this.maxValue) ]
  },
  methods: {
    closeDialog (action) {
      this.$emit('dialogNumberInputClose', this.componentKey, this.newValue, action, this.customPar1, this.customPar2)
    }
  }
}
</script>
